<div class="symptom-container" >
  <div id="print-section">
    <div class="back-container" (click)="back()">
      <span nz-icon nzType="arrow-left" nzTheme="outline"></span><span>{{ 'symptomAssessment.symptomDetails.back' | translate }}</span>
    </div>
    <h2>{{ 'symptomAssessment.symptomDetails.valutation_details' | translate }}</h2>
    <div class="references-data-container">
      <h3>{{ 'symptomAssessment.symptomDetails.reference' | translate }}</h3>
      <nz-divider></nz-divider>
      <div class="info-container">
        <div>
          <span class="title">{{ 'symptomAssessment.symptomDetails.date' | translate }}</span>
          <p>{{ symptomData.reference?.date }}</p>
        </div>
        <div>
          <span class="title">{{ 'symptomAssessment.symptomDetails.hours' | translate }}</span>
          <p>{{ symptomData.reference?.hours }}</p>
        </div>
      </div>
    </div>
      <div *ngIf="reportDetails.diagnoses && reportDetails.diagnoses.length">
          <p class="title-due">Analisi</p>
          <div *ngFor="let probability of reportDetails.diagnoses">
              <ul>
                  <li class="text">{{probability.label}} {{probability.probability}}%</li>
              </ul>
          </div>
      </div>
      <div *ngFor="let content of reportDetails.contents">
              <p class="title-due">{{content.title}}</p>
              <p class="text" [innerHTML]="content.text"></p>
          <div *ngIf="content.contents && content.contents.length">
              <div  *ngFor="let subContent of content.contents">
                  <p class="title-contents">{{subContent.title}}</p>
                  <p class="text-contents" [innerHTML]="subContent.text"></p>
              </div> 
  
          </div>
      </div>
  </div>
  <div class="button-container">
      <ds-button
      style="margin-right: 10px;"
      [text]="'INDIETRO'"
      [styleType]="'empty-main'"
      [width]="'small'"
      (click)="back()"
      ></ds-button>
      <ds-button *ngIf="!onMobile" 
      [text]="'STAMPA'" 
      [width]="'small'" 
      (click)="printSection()">
      </ds-button>
    </div>
</div>
